import { SxProps, Theme } from "@mui/material";

import { deepPurpleMui } from "../declarations";
import { rydeColors } from "./ryde-colors";

export const SxNavigationMenuTooltip: SxProps<Theme> = {
  bgcolor: deepPurpleMui.A400,
  border: `1px solid ${deepPurpleMui.A400}`,
  color: rydeColors.white,
  "& .MuiTooltip-arrow": {
    color: deepPurpleMui.A400,
  },
};

export const muiTooltipStyles = { ...SxNavigationMenuTooltip };
